import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '../../components/dashboard/Header'
import { Box, Link, Divider, Button, Collapse, Stack, Link as MuiLink, useMediaQuery } from '@mui/material'
import { t } from 'i18next'
import { EditNote } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { setEditTrainingsModal, setIsExamsEdited } from '../../store/reducers/modal.reducer'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TUser } from '../../shared/types/user.type'
import { useNavigate } from 'react-router-dom'
import { Link as RouterLink } from "react-router-dom";
import { useExam } from '../../hooks/useExam'
import { get, isEmpty, isNull, map, times, uniqBy } from 'lodash'
import ListExam from '../../components/exams/ListExam'
import { routes } from '../routes'
import { Ttraining } from '../../shared/types/training.type'
import Page from '../../components/layout/Helmet'
import { Icon } from '@iconify/react'
import HorsesCard from '../../components/dashboard/HorsesCard'
import StatsCard from '../../components/dashboard/StatsCard'
import { useQueryClient } from 'react-query'
import { Exams as ApiExams } from '../../api/exams'
import { hydraTransform } from '../../shared/utils/hydraTransformer'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useTheme } from "@mui/material/styles";
import { TPlatformConfiguration } from '../../shared/types/platformConfiguration'
import { useUserActivityLog } from '../../hooks/useUserActivityLog'

const ITEMS_PER_PAGE = 30

function Home() {
    const isUserLoading = useSelector<RootState>(state => state.user.isUserLoading) as boolean

    const isExamsEdited = useSelector<RootState>(state => state.modals.isExamsEdited) as boolean

    const auth = useSelector<RootState>(state => state.user.user) as TUser | null
    const [isRefreshing, setIsRefreshing] = useState(false);

    const [open, setOpen] = useState(true);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { track } = useUserActivityLog()

    const userConfigs = useSelector<RootState>(state => state.user.platformConfigurations) as TPlatformConfiguration[]




    useEffect(() => {
        track('DASHBOARD_PAGE_DISPLAYED')
    }, [])


    const [Exams, setExams] = useState<Ttraining[]>([])
    const [displayWaiting, setDisplayWaiting] = useState(false)


    const [page, setPage] = useState(1)


    const queryParams = useMemo(() => {

        let display = userConfigs?.find(conf => conf?.key === "DISPLAY_WAITING_TRAININGS_DASHBOARD")

        return [
            `itemsPerPage=${ITEMS_PER_PAGE}`,
            "include-total-count=true",
            `page=${page}`,
            ...((!display || display?.value === "false") ? [`exists[horseTrainer.horse]=1`] : displayWaiting ? [`exists[horseTrainer.horse]=0`] : [])
        ]
    }, [userConfigs, page])


    const { exams, isExamsLoading } = useExam(!isUserLoading, get(auth, '@id'), undefined, undefined, queryParams)
    //Hooks


    const queryClient = useQueryClient()
    const dispatch = useDispatch()




    useEffect(() => {
        const doRefresh = async () => {
            if (isExamsEdited) {
                dispatch(setIsExamsEdited(false));
                await refreshAndPushAllPages(null);
            }
        };
        doRefresh();
    }, [isExamsEdited]);



    const refreshAndPushAllPages = useCallback(async (waitingVal: null | boolean) => {
        const trainer = auth?.['@id'];
        if (!trainer) return;

        setIsRefreshing(true); // start loading
        const allFetched: Ttraining[] = [];



        const wait = isNull(waitingVal) ? displayWaiting : waitingVal

        for (let p = 1; p <= page; p++) {
            const queryParams = [
                `itemsPerPage=${ITEMS_PER_PAGE}`,
                'include-total-count=true',
                `page=${p}`,
                ...(wait
                    ? [`exists[horseTrainer.horse]=0`]
                    : [])
            ];

            try {
                const response = await queryClient.fetchQuery({
                    queryKey: ['new_exams', JSON.stringify(queryParams)],
                    queryFn: () => ApiExams.getExams(trainer, undefined, queryParams),
                    staleTime: 0,
                });

                const fetchedItems = hydraTransform(response.data) ?? [];
                allFetched.push(...fetchedItems);
            } catch (error) {
                console.error(`Failed to fetch exams for page ${p}`, error);
            }
        }

        setExams(allFetched);
        setIsRefreshing(false); // done loading
    }, [auth?.['@id'], userConfigs, displayWaiting, page]);
    useEffect(() => {
        setExams(prev => uniqBy([...prev, ...exams], exam => exam?.['@id']))

    }, [exams])


    const isAllLoaded = isEmpty(exams)


    const loadMore = () => {
        if (!isAllLoaded) {
            setPage(page + 1)
        }
    }

    const { i18n } = useTranslation();

    // let src = ""
    // if (isMobile && i18n.language === "fr") {
    //     src = require("../../assets/advertising/StableReview-Mobile-FR.png")
    // } else if (isMobile) {
    //     src = require("../../assets/advertising/StableReview-Mobile-EN.png")
    // } else if (!isMobile && i18n.language === "fr") {
    //     src = require("../../assets/advertising/StableReview-Desktop-FR.png")
    // } else if (!isMobile) {
    //     src = require("../../assets/advertising/StableReview-Desktop-EN.png")
    // }

    const src = isMobile ? require("../../assets/advertising/Arioneo-Advanced-TDN-Mobile.png") : require("../../assets/advertising/Arioneo-Advanced-TDN-Desktop.png");


    // Afficher la promo seulement avant Lundi 22 juin 2026 à 14:00 (heure locale)
    const showPromo = useMemo(() => {
        //return false
        return new Date() < new Date(2026, 10, 16, 14, 0, 0) // mois: 0=janvier, 1=février
    }, []);

    const handleUnassignedToggle = async (val: boolean) => {
        setDisplayWaiting(val);
        if (page !== 1) {
            setExams([])
            setPage(1)
        } else {
            await refreshAndPushAllPages(val)
        }
    }

    return (
        <Page withNameApp title={'navbar:dashboard'}>

            <Header text='navbar:dashboard'>

            </Header>

            <Divider sx={{ my: 2 }} />

            <Stack spacing={2}>
                {showPromo && (
                    <Box sx={{
                        position: "relative", width: "100%", mb: 2, ...(!open && {
                            minHeight: 40,
                            backgroundColor: "transparent"
                        })
                    }}>
                        <Button
                            onClick={() => setOpen((v) => !v)}
                            endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            variant="contained"
                            color="primary"
                            size="small"
                            sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                zIndex: 10,
                                textTransform: "none",
                                backgroundColor: "rgba(0,0,0,0.6)",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "rgba(0,0,0,0.8)",
                                },
                            }}
                            aria-expanded={open}
                            aria-controls="promo-image"
                        >
                        </Button>

                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <MuiLink
                                //component={RouterLink}
                                //to="/" //"/data-success"
                                href="https://arioneo.com/en/institute/train"
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="none"
                                sx={{ display: "block" }}
                            >
                                <Box
                                    id="promo-image"
                                    component="img"
                                    src={src}
                                    alt="Reports-Features"
                                    sx={{
                                        width: "100%",
                                        height: "auto",
                                        display: "block",
                                        borderRadius: 2,
                                        cursor: "pointer",
                                    }}
                                />
                            </MuiLink>
                        </Collapse>
                    </Box>
                )}
                <ListExam
                    exams={Exams}
                    isLoading={isExamsLoading || isRefreshing}
                    loadMore={loadMore}
                    allLoaded={isAllLoaded}
                    displayWaiting={displayWaiting}
                    onDisplayChange={handleUnassignedToggle}
                ></ListExam>
                <HorsesCard />
                <StatsCard />
            </Stack>
        </Page>
    )
}

export default Home